<template>
    <div v-if="option.imgs && option.imgs.length > 0" class="collect-form-item-option-img-wapper">
        <van-image
            v-for="(img, imgIdx) in option.imgs"
            :key="imgIdx"
            class="collect-form-item-option-img"
            :src="'/idata' + img"
            fit="contain"
            @click.stop="previewImg('/idata' + img)"
        />
    </div>
</template>

<script>
import { ImagePreview } from "vant";

export default {
    components: {
        [ImagePreview.Component.name]: ImagePreview.Component
    },
    props: ["option"],
    data() {
        return {

        }
    },
    created() {

    },
    methods: {
        // 图片预览方法
        previewImg(src) {
            ImagePreview({
                images: [src],
                closeable: true,
                showIndex: false,
            });
        },
    }
}
</script>
<style scoped>
</style>